import { Category, userRoles } from "../store/slices/storeSlice";
import { store } from "../store/store";

export const getToken = () => {
  return localStorage.getItem("user")
    ? "Bearer " + JSON.parse(localStorage.getItem("user")).token
    : null;
};

export const getUID = () => {
  return localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user")).uid
    : null;
};

// export const getFileUrl = async (text) => {
//   if (!text) return text;
//   if (text.indexOf("amazonaws") !== -1) return text;
//   else {
//     const refObj = ref(storage, text);
//     const url = await getDownloadURL(refObj);
//     console.log("safafsfw", url);
//     if (url) return url;
//     else return text;
//   }
// };

export const getFileUrl = (url: string) => {
  // return encodeURIComponent(url.split("&token=")[0]);
  // if(url.indexOf("&token=") === -1) return url;
  return url.split("&token=")[0];

  // const withoutToken = url.split("&token=")[0];
  // const onlyFileName = withoutToken
  //   ?.split(
  //     "https://firebasestorage.googleapis.com/v0/b/eliteacademyeg-a7552.appspot.com/o/"
  //   )[1]
  //   ?.split("?")[0];

  // return `https://firebasestorage.googleapis.com/v0/b/eliteacademyeg-a7552.appspot.com/o/${encodeURIComponent(
  //   onlyFileName
  // )}?alt=media`;
};

export const base64ToBlob = (base64URLString: string) => {
  // Split the base64 string into the content type and the data
  const parts = base64URLString.split(";base64,");
  const contentType = parts[0].split(":")[1];
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uint8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uint8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uint8Array], { type: contentType });
};

export const isPhoneValid = (phoneNumber) => {
  let isValidStart = /^01/.test(phoneNumber);
  if (!isValidStart) {
    return {
      isValid: false,
      message: "يجب ان يبدأ رقم الهاتف بـ 01 باللغة الإنجليزية",
    };
  }

  let isAllNumbers = /^\d+$/.test(phoneNumber);
  if (!isAllNumbers) {
    return {
      isValid: false,
      message: "يجب ان يحتوي رقم الهاتف علي ارقام فقط",
    };
  }

  let isValidLength = /^\d{11}$/.test(phoneNumber);
  if (!isValidLength) {
    return {
      isValid: false,
      message: "يجب ان يحتوي رقم الهاتف علي 11 رقم فقط",
    };
  }

  return {
    isValid: true,
    message: null,
  };
};

export const isNameValid = (name) => {
  let isAllLettersAndAtLeast15Chars = /^[\u0600-\u06FF ]{15,}$/.test(name);
  if (name?.split(" ").length < 4) {
    return {
      isValid: false,
      message: "يجب ان يكون الإسم رباعي",
    };
  }
  if (!isAllLettersAndAtLeast15Chars) {
    return {
      isValid: false,
      message:
        "يجب ان يحتوي الاسم الرباعي علي حروف عربية فقط ويجب ان يكون علي الاقل 15 حرف",
    };
  }

  return {
    isValid: true,
    message: null,
  };
};

export const isTutorNameValid = (name) => {
  let isAllLettersAndAtLeast15Chars = /^[\u0600-\u06FF ]{6,}$/.test(name);
  if (name?.split(" ").length < 2) {
    return {
      isValid: false,
      message: "يجب ان يكون الإسم ثنائي",
    };
  }
  if (!isAllLettersAndAtLeast15Chars) {
    return {
      isValid: false,
      message:
        "يجب ان يحتوي الاسم الثنائي علي حروف عربية فقط ويجب ان يكون علي الاقل ٦ أحرف",
    };
  }

  return {
    isValid: true,
    message: null,
  };
};

export const isEmailValid = (email) => {
  let isValid =
    /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,4})$/.test(email);
  if (!isValid) {
    return {
      isValid: false,
      message: "هذا الإيميل غير صحيح",
    };
  }

  return {
    isValid: true,
    message: null,
  };
};

export const textToUnicode = (text) => {
  const unicodeCodePoints = [];
  for (let i = 0; i < text?.length; i++) {
    unicodeCodePoints.push(text.charCodeAt(i));
  }
  return unicodeCodePoints;
};

export const unicodeToText = (codePoints) => {
  return codePoints.map((code) => String.fromCharCode(code)).join("");
};

export const genRandID = (count = 1) => {
  const numbers = [];
  for (let i = 0; i < count; i++) {
    numbers.push(Math.floor(Math.random() * 10000)); // Generates a random number between 0 and 9999
  }
  return numbers.join("");
};

export function sanitizeUrl(url) {
  // Remove invalid characters (e.g., spaces, special characters)
  const sanitizedUrl = url.replace(/[^a-zA-Z0-9._-]/g, "");

  // Remove leading and trailing slashes
  return sanitizedUrl.replace(/^\/|\/$/g, "");
}

export const reorderForPagination = ({
  arr,
  currentPage,
  pageCount,
}: {
  arr: any[];
  currentPage: number;
  pageCount: number;
}) => {
  return arr.slice((currentPage - 1) * pageCount, currentPage * pageCount);
};

export const dateFormatter = (
  dateStr: string | number,
  weekday = false,
  year = false
) => {
  // Define the Arabic and English numeral mappings
  const arabicNumbers = "٠١٢٣٤٥٦٧٨٩".split("");
  const englishNumbers = "0123456789".split("");

  const date = `${new Date(dateStr)
    .toLocaleString("ar-EG", {
      day: "2-digit",
      month: "long",
      year: year ? "numeric" : undefined,
      weekday: weekday ? "long" : undefined,
    })
    .replace(
      /[٠١٢٣٤٥٦٧٨٩]/g,
      (x) => englishNumbers[arabicNumbers.indexOf(x)]
    )} - ${new Date(dateStr)
    .toLocaleString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .replaceAll("AM", "ص")
    .replaceAll("PM", "م")}`;

  return date;
};

export const playNotificationSound = () => {
  try {
    const audio = new Audio(
      "https://eliteacademymedia.s3.us-east-1.amazonaws.com/qashqool_assets/media/notification.mp3"
    );
    audio.play();
  } catch (e) {
    console.log(e);
  }
};

export const isTeacher = () => {
  const user = store.getState().store.user;
  return (
    user?.role === userRoles.TEACHER ||
    user?.role === userRoles.ADMIN ||
    user?.role === userRoles.ASSISTANT
  );
};

export const isSubscribed = () => {
  const userProfileData = store.getState().store.userProfileData;
  if (userProfileData?.subscription_tier === "free") return false;
  return Number(userProfileData?.subscription_end_date) > Date.now();
};

export const isProSubscription = () => {
  const userProfileData = store.getState().store.userProfileData;
  return userProfileData?.subscription_tier === "pro";
};

export const isSubscriptionExpired = () => {
  const userProfileData = store.getState().store.userProfileData;
  return Number(userProfileData?.subscription_end_date) < Date.now();
};

export const currentTier = () => {
  const userProfileData = store.getState().store.userProfileData;
  return userProfileData?.subscription_tier;
};

export function hasHyphenAtEdges(str: string) {
  // Regular expression to check for hyphens at the start or end of the string
  const regex = /^-|-$/;
  return regex.test(str);
}

export function isEnglishOrHyphen(str: string) {
  // Regular expression to match only English letters and hyphens
  const regex = /^[A-Za-z\-]+$/;
  return regex.test(str);
}

export const getDeviceId = () => {
  const id = localStorage.getItem("deviceId");
  if (id) return Number(id);
  const newId = genRandID(4);
  localStorage.setItem("deviceId", newId);
  return Number(newId);
};

export const getFileName = (url: string) => {
  return decodeURIComponent(
    url
      .split("firebasestorage.app/o/files-")[1]
      .split("?alt=media")[0]
      .split("-")[1]
  );
};

export const convertText = (encoded: string) => {
  if (!encoded) return encoded;
  const textarea = document.createElement("textarea");
  textarea.innerHTML = encoded;
  const decoded = textarea.value;
  return decoded;
};

// Assistant permission utilities
export const isAssistant = () => {
  const user = store.getState().store.user;
  return user?.role === userRoles.ASSISTANT;
};

export const isTeacherOrAdmin = () => {
  const user = store.getState().store.user;
  return user?.role === userRoles.TEACHER || user?.role === userRoles.ADMIN;
};

export const canRenewSubscription = () => {
  const user = store.getState().store.user;
  const userProfileData = store.getState().store.userProfileData;

  if (user?.role === userRoles.TEACHER || user?.role === userRoles.ADMIN) {
    return true;
  }

  if (user?.role === userRoles.ASSISTANT) {
    return userProfileData?.permissions?.can_renew_subscription ?? false;
  }

  return false;
};

export const canCreateQuizzes = () => {
  const user = store.getState().store.user;
  const userProfileData = store.getState().store.userProfileData;

  if (user?.role === userRoles.TEACHER || user?.role === userRoles.ADMIN) {
    return true;
  }

  if (user?.role === userRoles.ASSISTANT) {
    return userProfileData?.permissions?.can_create_quizzes ?? false;
  }

  return false;
};

export const canCreateHomework = () => {
  const user = store.getState().store.user;
  const userProfileData = store.getState().store.userProfileData;

  if (user?.role === userRoles.TEACHER || user?.role === userRoles.ADMIN) {
    return true;
  }

  if (user?.role === userRoles.ASSISTANT) {
    return userProfileData?.permissions?.can_create_homework ?? false;
  }

  return false;
};

export const canViewQuizGrades = () => {
  const user = store.getState().store.user;
  const userProfileData = store.getState().store.userProfileData;

  if (user?.role === userRoles.TEACHER || user?.role === userRoles.ADMIN) {
    return true;
  }

  if (user?.role === userRoles.ASSISTANT) {
    return userProfileData?.permissions?.can_view_quiz_grades ?? false;
  }

  return false;
};

export const canViewHomeworkGrades = () => {
  const user = store.getState().store.user;
  const userProfileData = store.getState().store.userProfileData;

  if (user?.role === userRoles.TEACHER || user?.role === userRoles.ADMIN) {
    return true;
  }

  if (user?.role === userRoles.ASSISTANT) {
    return userProfileData?.permissions?.can_view_homework_grades ?? false;
  }

  return false;
};

export const canPublishLessons = (categoryId?: number) => {
  const user = store.getState().store.user;
  const userProfileData = store.getState().store.userProfileData;

  if (user?.role === userRoles.TEACHER || user?.role === userRoles.ADMIN) {
    return true;
  }

  if (user?.role === userRoles.ASSISTANT) {
    const allowedCategories =
      userProfileData?.permissions?.can_publish_lessons ?? [];
    if (!categoryId) return allowedCategories.length > 0;
    return allowedCategories.includes(categoryId);
  }

  return false;
};

export const canEditLessons = (categoryId?: number) => {
  const user = store.getState().store.user;
  const userProfileData = store.getState().store.userProfileData;

  if (user?.role === userRoles.TEACHER || user?.role === userRoles.ADMIN) {
    return true;
  }

  if (user?.role === userRoles.ASSISTANT) {
    const allowedCategories =
      userProfileData?.permissions?.can_edit_lessons ?? [];
    if (!categoryId) return allowedCategories.length > 0;
    return allowedCategories.includes(categoryId);
  }

  return false;
};

export const canViewSales = (categoryId?: number) => {
  const user = store.getState().store.user;
  const userProfileData = store.getState().store.userProfileData;

  if (user?.role === userRoles.TEACHER || user?.role === userRoles.ADMIN) {
    return true;
  }

  if (user?.role === userRoles.ASSISTANT) {
    const allowedCategories =
      userProfileData?.permissions?.can_view_sales ?? [];
    if (!categoryId) return allowedCategories.length > 0;
    return allowedCategories.includes(categoryId);
  }

  return false;
};

export const canCreateCodes = (categoryId?: number) => {
  const user = store.getState().store.user;
  const userProfileData = store.getState().store.userProfileData;

  if (user?.role === userRoles.TEACHER || user?.role === userRoles.ADMIN) {
    return true;
  }

  if (user?.role === userRoles.ASSISTANT) {
    const allowedCategories =
      userProfileData?.permissions?.can_create_codes ?? [];
    if (!categoryId) return allowedCategories.length > 0;
    return allowedCategories.includes(categoryId);
  }

  return false;
};

export const canManageStudents = (categoryId?: number) => {
  const user = store.getState().store.user;
  const userProfileData = store.getState().store.userProfileData;

  if (user?.role === userRoles.TEACHER || user?.role === userRoles.ADMIN) {
    return true;
  }

  if (user?.role === userRoles.ASSISTANT) {
    const allowedCategories =
      userProfileData?.permissions?.can_manage_students ?? [];
    if (!categoryId) return allowedCategories.length > 0;
    return allowedCategories.includes(categoryId);
  }

  return false;
};

/**
 * Get all categories that the assistant has ANY permission for
 * This is useful for filtering the UI to show only relevant categories
 * WARNING: This does NOT mean the assistant has all permissions for these categories
 * Always use specific permission checks (canPublishLessons, canEditLessons, etc.)
 */
export const getAllowedCategoriesForDisplay = () => {
  const user = store.getState().store.user;
  const userProfileData = store.getState().store.userProfileData;

  if (user?.role === userRoles.TEACHER || user?.role === userRoles.ADMIN) {
    return null; // null means all categories
  }

  if (user?.role === userRoles.ASSISTANT) {
    const permissions = userProfileData?.permissions;
    if (!permissions) return [];

    // Collect all unique category IDs from all permissions
    // This is ONLY for display purposes - showing categories in dropdowns/lists
    const allCategories = new Set<number>();
    permissions.can_publish_lessons?.forEach((id) => allCategories.add(id));
    permissions.can_edit_lessons?.forEach((id) => allCategories.add(id));
    permissions.can_view_sales?.forEach((id) => allCategories.add(id));
    permissions.can_create_codes?.forEach((id) => allCategories.add(id));
    permissions.can_manage_students?.forEach((id) => allCategories.add(id));

    return Array.from(allCategories);
  }

  return [];
};

export const getAncestors = (
  categories: Category[],
  termId: number
): Category[] => {
  const cat = categories.find((c) => c.term_id === termId);
  if (!cat || cat.parent === 0) return []; // no parent or not found
  const parent = categories.find((c) => c.term_id === cat.parent);
  return parent ? [parent, ...getAncestors(categories, parent.term_id)] : [];
};

export const getDescendants = (
  categories: Category[],
  termId: number
): Category[] => {
  const children = categories.filter((c) => c.parent === termId);
  return children.flatMap((child) => [
    child,
    ...getDescendants(categories, child.term_id),
  ]);
};

/**
 * Get categories for a specific permission type
 */
export const getAllowedCategoriesForPermission = (
  permissionType:
    | "can_publish_lessons"
    | "can_edit_lessons"
    | "can_view_sales"
    | "can_create_codes"
    | "can_manage_students"
) => {
  const user = store.getState().store.user;
  const userProfileData = store.getState().store.userProfileData;
  const portal = store.getState().store.portal;

  if (user?.role === userRoles.TEACHER || user?.role === userRoles.ADMIN) {
    return null; // null means all categories
  }

  if (user?.role === userRoles.ASSISTANT) {
    let allowed_cats: Set<number> = new Set<number>();
    const permissions = userProfileData?.permissions;
    for (const catId of permissions?.[permissionType] ?? []) {
      allowed_cats.add(catId);
      getAncestors(portal?.cats || [], catId).forEach((cat) =>
        allowed_cats.add(cat.term_id)
      );
      getDescendants(portal?.cats || [], catId).forEach((cat) =>
        allowed_cats.add(cat.term_id)
      );
    }
    return Array.from(allowed_cats);
  }

  return [];
};
